import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall, AxiosPost } from "../../../utils/axios";
import { getFbTrackingPayload } from "../../../utils/fbTracking";
import * as actions from "./actions";

function* fetchTarotCards() {
  try {
    const result = yield call(AxiosCall, `/tarot/get_cards/`);
    const { results, count } = result.data;
    yield put(actions.fetchTarotCardsSuccess(results, count));
  } catch (e) {
    yield put(actions.fetchTarotCardsFailure(e));
  }
}

function* createPendingThreeCard(action) {
  try {
    const result = yield call(AxiosPost, `/tarot/create_pending_threecardreading/`, action.payload);
    yield put(actions.createPendingThreeCardSuccess(result.data.reading_id));
  } catch (e) {
    yield put(actions.createPendingThreeCardFailure(e));
  }
}

function* tarotCheckout(action) {
  try {
    const result = yield call(AxiosPost, `/tarot/create_checkout/`, { ...action.payload, ...getFbTrackingPayload() });
    yield put(actions.tarotCheckoutSuccess());
    window.location.href = result.data.checkout_url;
  } catch (e) {
    yield put(actions.tarotCheckoutFailure(e));
  }
}

function* tarotPaypalOrder(action) {
  try {
    const result = yield call(AxiosPost, `/tarot/create_paypal_order/`, { ...action.payload, ...getFbTrackingPayload() });
    yield put(actions.tarotPaypalOrderSuccess());
    window.location.href = result.data.approve_url;
  } catch (e) {
    yield put(actions.tarotPaypalOrderFailure(e));
  }
}

function* tarotVerify(action) {
  try {
    const result = yield call(AxiosPost, `/tarot/verify_purchase/`, action.payload);
    yield put(actions.tarotVerifyPurchaseSuccess(result.data));
  } catch (e) {
    yield put(actions.tarotVerifyPurchaseFailure(e));
  }
}

function* tarotVerifyPaypal(action) {
  try {
    const result = yield call(AxiosPost, `/tarot/verify_paypal_purchase/`, { ...action.payload, ...getFbTrackingPayload() });
    yield put(actions.tarotVerifyPaypalSuccess(result.data));
  } catch (e) {
    yield put(actions.tarotVerifyPaypalFailure(e));
  }
}

export default function* tarotCardsSaga() {
  yield all([
    takeLatest(actions.FETCH_TAROT_CARDS_REQUEST, fetchTarotCards),
    takeLatest(actions.CREATE_PENDING_THREECARD_REQUEST, createPendingThreeCard),
    takeLatest(actions.TAROT_CHECKOUT_REQUEST, tarotCheckout),
    takeLatest(actions.TAROT_PAYPAL_REQUEST, tarotPaypalOrder),
    takeLatest(actions.TAROT_VERIFY_REQUEST, tarotVerify),
    takeLatest(actions.TAROT_VERIFY_PAYPAL_REQUEST, tarotVerifyPaypal),
  ]);
}
